import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const AuthErrorHandler: React.FC = () => {
  const { error, clearError, resetAuthState, loading } = useAuth();

  if (!error) return null;

  const handleReset = async () => {
    try {
      await resetAuthState();
      // Small delay to ensure state is reset before clearing error
      setTimeout(() => {
        clearError();
      }, 100);
    } catch (error) {
      console.error('Error during reset:', error);
      // Still clear the error even if reset failed
      clearError();
    }
  };

  const handleDismiss = () => {
    clearError();
  };

  return (
    <div className="fixed top-4 right-4 z-50 max-w-md">
      <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 shadow-lg">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-red-400" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
            </svg>
          </div>
          
          <div className="ml-3 flex-1">
            <h3 className="text-sm font-medium text-red-800 dark:text-red-200">
              Authentication Error
            </h3>
            <div className="mt-2 text-sm text-red-700 dark:text-red-300">
              <p>{error}</p>
            </div>
            
            <div className="mt-3 flex flex-col sm:flex-row gap-2">
              <button
                onClick={handleReset}
                disabled={loading}
                className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                {loading ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Resetting...
                  </>
                ) : (
                  'Reset Authentication'
                )}
              </button>
              
              <button
                onClick={handleDismiss}
                className="inline-flex items-center px-3 py-2 border border-gray-300 dark:border-gray-600 text-sm leading-4 font-medium rounded-md text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
              >
                Dismiss
              </button>
            </div>
            
            <div className="mt-3 text-xs text-red-600 dark:text-red-400">
              <p>
          <img 
            src="https://unpkg.com/pixelarticons@1.8.0/svg/info.svg" 
            alt="Tip" 
            className="w-4 h-4 inline-block mr-2"
            style={{ filter: 'brightness(0) saturate(100%) invert(60%)' }}
          />
          Tip: If problems persist, try refreshing the page or signing out and back in.
        </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthErrorHandler; 